import HowItWorksV2 from '~/components/RS_Introduction'

const HowItWorks = HowItWorksV2

// @ts-ignore
HowItWorks.getInitialProps = () => {
  return {
    namespacesRequired: ['common']
  }
}

export default HowItWorks
